module.exports = __webpack_public_path__ + "mainassets/img/floating-objects-cookie.44923c83.svg";